import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { IconButton, Box, Typography } from "@mui/material";

import { getToken } from "../../utils/utils";
import { getapprovalhistoryofbrands, getbrandetails } from "./api";
import { useParams } from "react-router-dom";
interface RowData {
  id: number;
  requestedOn: string;
  brandName: string;
  availableLocations: string;
  tenPackMRP: number;
  twentyPackMRP: number;
  brandImage: string;
  status: string;
}
interface BrandTableProps {
  branddetails1: any;
}
const BrandTable: React.FC<BrandTableProps> = ({ branddetails1 }) => {
  const { id } = useParams();
  console.log(JSON.stringify(branddetails1, null, 2), "branddetails1branddetails1branddetails122");
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
  const [approvalhistory, setapprovalhistory] = useState<RowData[]>([]);
  const token = getToken();


  const rows: RowData[] = [
    {
      id: 1,
      requestedOn: "12 Nov 2024",
      brandName: "Marlboro Golddddddd",
      availableLocations: "Delhi, Mumbai",
      tenPackMRP: 170,
      twentyPackMRP: 250,
      brandImage: "IMG_12",
      status: "Approved",
    },
    {
      id: 2,
      requestedOn: "15 Nov 2024",
      brandName: "Camel Blue",
      availableLocations: "Kolkata",
      tenPackMRP: 160,
      twentyPackMRP: 240,
      brandImage: "IMG_13",
      status: "Pending",
    },
  ];






  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedApprovalHistory = [...branddetails1].sort((a, b) => {
    if (!orderBy) return 0;

    let aVal: string | number = a[orderBy];
    let bVal: string | number = b[orderBy];

    if (orderBy === "requestedOn") {
      aVal = new Date(aVal).getTime();
      bVal = new Date(bVal).getTime();
    }

    if (aVal < bVal) return order === "asc" ? -1 : 1;
    if (aVal > bVal) return order === "asc" ? 1 : -1;
    return 0;
  });



  console.log(approvalhistory, "approvalhistorydeeeeeeeeee")
  return (
    <Box>
      <Typography
        variant="h3"
        sx={{
          fontSize: "18px",
          color: "#282829",
          fontWeight: "600",
          padding: "20px",
          background: "#fff",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        Approval History
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="sortable table">
          <TableHead sx={{ background: "#EEF4FF" }}>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "id"}
                  direction={orderBy === "id" ? order : "asc"}
                  onClick={() => handleSort("id")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  S.No
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "requestedOn"}
                  direction={orderBy === "requestedOn" ? order : "asc"}
                  onClick={() => handleSort("requestedOn")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  Requested on
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "brandName"}
                  direction={orderBy === "brandName" ? order : "asc"}
                  onClick={() => handleSort("brandName")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  Brand Name
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "availableLocations"}
                  direction={orderBy === "availableLocations" ? order : "asc"}
                  onClick={() => handleSort("availableLocations")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  Available Locations
                </TableSortLabel>

              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "tenPackMRP"}
                  direction={orderBy === "tenPackMRP" ? order : "asc"}
                  onClick={() => handleSort("tenPackMRP")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  10's Pack MRP
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "twentyPackMRP"}
                  direction={orderBy === "twentyPackMRP" ? order : "asc"}
                  onClick={() => handleSort("twentyPackMRP")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  20's Pack MRP
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "brandImage"}
                  direction={orderBy === "brandImage" ? order : "asc"}
                  onClick={() => handleSort("brandImage")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  Brand Images
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === "status"}
                  direction={orderBy === "status" ? order : "asc"}
                  onClick={() => handleSort("status")}
                  sx={{
                    "& .MuiTableSortLabel-icon": {
                      opacity: 1,
                    },
                  }}
                >
                  Status
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedApprovalHistory.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.requestedOn}</TableCell>
                <TableCell>{row.brandName}</TableCell>
                <TableCell>{row.availableLocations}</TableCell>
                <TableCell>{row.tenPackMRP}</TableCell>
                <TableCell>{row.twentyPackMRP}</TableCell>
                <TableCell>{row.brandImage}</TableCell>
                {/* <TableCell>
                  <IconButton>
                    <Image src={row.brandImage} alt="Brand Image" />
                  </IconButton>
                </TableCell> */}
                <TableCell>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BrandTable;
